
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/granton-trams",
      function () {
        return require("private-next-pages/granton-trams.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/granton-trams"])
      });
    }
  